import { AfterViewInit, Component, Input } from '@angular/core';
import { LngLat, YMap, YMapLocationRequest } from '@yandex/ymaps3-types';
import { NgxMaskPipe } from 'ngx-mask';

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss'],
  standalone: true,
  providers: [NgxMaskPipe],
})
export class MapComponent implements AfterViewInit {
  map: YMap;
  mapLocation: YMapLocationRequest;

  @Input() coordinateCenter: any[] = [];
  @Input() price = 0;

  constructor(private _mask: NgxMaskPipe) {}
  ngAfterViewInit() {
    this.initYMap();
  }

  async initYMap() {
    await ymaps3.ready;
    const { YMap, YMapDefaultSchemeLayer, YMapDefaultFeaturesLayer } = ymaps3;
    this.mapLocation = {
      zoom: 16,
      center: this.coordinateCenter as LngLat,
      easing: 'linear',
      duration: 500,
    };
    this.map = new YMap(
      document.getElementById('flat-map'),
      { location: this.mapLocation, zoomRange: { min: 5, max: 18 }, zoomStrategy: 'zoomToPointer', zoomRounding: 'smooth', showScaleInCopyrights: true, theme: 'dark' },
      [new YMapDefaultSchemeLayer({}), new YMapDefaultFeaturesLayer({})],
    );
    this.createMarker();
  }

  async createMarker() {
    const { YMapMarker } = ymaps3;
    const marker = new YMapMarker({ coordinates: this.coordinateCenter as LngLat }, this.createHTMLMarkerElement());
    this.map.addChild(marker);
  }

  createHTMLMarkerElement() {
    const markerContainerElement = document.createElement('div');
    markerContainerElement.classList.add('marker');
    const image = document.createElement('img');
    image.src = 'assets/images/new-design-icons/map-marker-detail.svg';
    image.classList.add('marker-icon');
    const price = document.createElement('span');
    price.classList.add('price');
    price.innerText = `${this._mask.transform(this.price, 'separator.2')}₸`;
    markerContainerElement.appendChild(price);
    markerContainerElement.appendChild(image);
    return markerContainerElement;
  }
}
